@let i18n = translate();
@let testId = 'rcp-message-dialog-' + data.testId;

<mat-dialog-content
    class="!rcp-pb-0 !rcp-pt-6"
    [attr.data-testid]="'rcp-message-dialog-title'"
>
    @if (showAlertType()) {
        <div
            class="rcp-alert-type"
            [ngClass]="{
                'rcp-bg-ul-green-100': data.alertType === alertType.Success,
                'rcp-bg-ul-red-100': data.alertType === alertType.Error,
                'rcp-bg-ul-yellow-100': data.alertType === alertType.Warning,
                'rcp-bg-ul-blue-200': data.alertType === alertType.Info,
            }"
        >
            <mat-icon
                class="rcp-alert-type-{{ data.alertType }}"
                [ngClass]="{
                    '!rcp-pt-1.5':
                        data.alertType === alertType.Success ||
                        data.alertType === alertType.Error,
                    '!rcp-pt-1': data.alertType === alertType.Warning,
                    'rcp-text-ul-green-300': data.alertType === alertType.Success,
                    'rcp-text-danger!': data.alertType === alertType.Error,
                    'rcp-text-ul-yellow-400': data.alertType === alertType.Warning,
                    'rcp-text-ul-blue-400': data.alertType === alertType.Info,
                }"
                attr.data-testid="{{ testId }}-alert-icon"
            >
                {{ alertTypes[data.alertType] }}
            </mat-icon>
        </div>
    }
    <h2
        class="rcp-pb-3 rcp-pt-5 rcp-font-poppins rcp-text-2xl"
        attr.data-testid="{{ testId }}-title"
    >
        {{ data.title }}
    </h2>
    <div
        class="rcp-text-sm"
        attr.data-testid="{{ testId }}-message"
        [innerHTML]="data.message"
    ></div>

    @if ((data.logInfo || []).length > 0) {
        <div
            class="rcp-mt-[39px]"
            attr.data-testid="{{ testId }}-logInfo"
        >
            @for (info of data.logInfo; track info) {
                <p
                    class="rcp-pb-[10px]"
                    attr.data-testid="{{ testId }}-log-info"
                >
                    {{ info.label }}: <b>{{ info.value }}</b>
                </p>
            }
        </div>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <div class="rcp-mt-4 rcp-w-full rcp-pb-2">
        @if (
            (leftActions && leftActions.length > 0) ||
            (rightActions && rightActions.length > 0)
        ) {
            <div class="rcp-flex rcp-w-full rcp-items-center rcp-justify-between">
                <div>
                    @if (leftActions && leftActions.length > 0) {
                        <app-dynamic-actions
                            [actions]="leftActions"
                            [testIdPrefix]="testId"
                        ></app-dynamic-actions>
                    }
                </div>
                <div>
                    @if (rightActions && rightActions.length > 0) {
                        <app-dynamic-actions
                            [actions]="rightActions"
                            [testIdPrefix]="testId"
                        >
                        </app-dynamic-actions>
                    }
                </div>
            </div>
        } @else {
            <button
                mat-button
                attr.data-testid="{{ testId }}-close-btn"
                (click)="onOkClick($event)"
            >
                {{ i18n.ACTION__Close }}
            </button>
        }
    </div>
</mat-dialog-actions>
